"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateLogPayloadSchema = exports.findingMergedFromAnalysisUpdateLogPayloadSchema = exports.findingUnlinkedAssertionResultsUpdateLogPayloadSchema = exports.findingLinkedAssertionResultsUpdateLogPayloadSchema = exports.findingCreatedWithAssertionResultsUpdateLogPayloadSchema = void 0;
const zod_1 = require("zod");
exports.findingCreatedWithAssertionResultsUpdateLogPayloadSchema = zod_1.z.object({
    kind: zod_1.z.literal('finding-created-with-assertion-results'),
    assertionResultIds: zod_1.z.array(zod_1.z.string()),
});
exports.findingLinkedAssertionResultsUpdateLogPayloadSchema = zod_1.z.object({
    kind: zod_1.z.literal('finding-linked-assertion-results'),
    assertionResultIds: zod_1.z.array(zod_1.z.string()),
});
exports.findingUnlinkedAssertionResultsUpdateLogPayloadSchema = zod_1.z.object({
    kind: zod_1.z.literal('finding-unlinked-assertion-results'),
    assertionResultIds: zod_1.z.array(zod_1.z.string()),
});
exports.findingMergedFromAnalysisUpdateLogPayloadSchema = zod_1.z.object({
    kind: zod_1.z.literal('finding-merged-from-analysis'),
});
exports.UpdateLogPayloadSchema = zod_1.z.discriminatedUnion('kind', [
    exports.findingCreatedWithAssertionResultsUpdateLogPayloadSchema,
    exports.findingLinkedAssertionResultsUpdateLogPayloadSchema,
    exports.findingMergedFromAnalysisUpdateLogPayloadSchema,
    exports.findingUnlinkedAssertionResultsUpdateLogPayloadSchema,
]);
//# sourceMappingURL=update-log-payload.js.map